var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentSpend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#06004a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.96-69q-47.38 0-80.38-33-32.99-32.99-32.99-80.48v-130.87h129.87v-570.72l61.23 60.96 60.94-60.96 60.94 60.96 60.94-60.96 60.95 60.96 61.14-60.96 61.09 60.96 61.09-60.96 60.96 60.96 61.67-60.96v701.7q0 47.38-33.06 80.37-33.07 33-80.31 33H222.96Zm512.58-68.37q19.5 0 31.5-12.5t12-32.5v-608.61H310.59v527.63h385.45v80.98q0 20 10 32.5t29.5 12.5ZM363.59-635.54v-60h235.45v60H363.59Zm0 134v-60h235.45v60H363.59Zm328.45-134q-12 0-21-9t-9-21q0-12 9-21t21-9q12 0 21 9t9 21q0 12-9 21t-21 9Zm0 129q-12 0-21-9t-9-21q0-12 9-21t21-9q12 0 21 9t9 21q0 12-9 21t-21 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentSpend);
export default __webpack_public_path__ + "static/media/current-spend.ae34c0cfb080d6155ecddc837e3265b0.svg";
export { ForwardRef as ReactComponent };